import React from "react";
import Header from "../../components/header";
import Navbar from "../../components/navbar";
import Footer from "../../components/footer";

import Banner from "../../images/leistungen/bg_hand_herz.png";

import EKGImage from "../../images/leistungen/ekg.jpg"

const EKG = () => {
    return (
        <main> 
            <Header image={Banner}/>
            <section className="content-section">
                <Navbar />

                <div className="page-container">
                    <h1> Leistung - EKG </h1>
                    <img src={EKGImage} style={{float: "right", margin:"15px"}}/>
                    <p className="page-text">
                        <b> Wozu ein EKG? Wir können damit folgende Parameter feststellen: </b>
                        <ul>
                            <li> Herzrhythmus und Herzfrequenz </li>
                            <li> Störungen der Erregungsbildung, -ausbreitung und -rückbildung im Erregungsleitungssystem sowie in der Herzmuskulatur </li>
                            <li> Lagetyp des Herzens  </li>
                        </ul>
                        <br /> <br />
                        Das EKG ist besonders wichtig zur Diagnostik einer koronaren Herzerkrankung, Herzmuskelentzündungen, Elektrolytverschiebungen, Rhythmusstörungen, Bluthochdruck , Nebenwirkungen bestimmter Medikamente, etc.
                        <br /> <br /> 
                        <b> Wie wird ein EKG durchgeführt? </b>
                        <br/> Bei einem Ruhe-EKG liegt der Patient entspannt mit freiem Oberkörper da, er befindet sich im körperlichen Ruhezustand. Die Elektroden werden mit einem Saugsystem auf die Haut gesetzt und abgeleitet.
                    </p>
                </div>

            </section>
            <Footer />
        </main>
    )
}

export default EKG;